module.exports = __webpack_public_path__ + "img/Centro-Oeste.b3cdac5e.png";